export default {
	slots: {
		root: 'text-dimmed',
		list: 'gap-0 px-0',
		item: 'px-2.5',
		link: 'px-0 hover:duration-0',
		separator: 'px-0.5 text-xs text-disabled',
	},
	variants: {
		active: {
			true: {
				link: 'font-semibold text-default',
			},
			false: {
				link: 'font-semibold',
			},
		},
	},
};
